module.exports = __webpack_public_path__ + "images/category_lp/smartwatch/assessment_achievements/5_3866d606ae0201bff2daafb9947b98c0.jpg";